import axios, { AxiosPromise } from 'axios';

import { IOrderHeader } from '../../../@types/model/order/orderHeader';

export default class OrderHttpService {
    public static getOrderHeaderData() : AxiosPromise<Array<IOrderHeader>> {
        return axios.get(`${API_URL}/v1/Order/GetAllWeb`);
    }

    public static addOrUpdateOrderHeader(data : IOrderHeader) : AxiosPromise<IOrderHeader> {
        return axios.post(`${API_URL}/v1/Order/PostOrder`, data);
    }
}
